import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateFinSwimAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitFinSwimResultInput;
}>;


export type CreateFinSwimAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitFinSwimResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'message' | 'field'>
    )>> }
  ) | (
    { __typename: 'SubmitFinSwimResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & FinSwimAssessmentResultFragment
    )> }
  ) }
);

export type FinSwimAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'role' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'BmpResult' } | { __typename: 'CardioRespResult' } | (
    { __typename: 'FinSwimResult' }
    & FinSwimAssessmentResultDataFragment
  ) | { __typename: 'IpptResult' } | { __typename: 'ML360Result' } | { __typename: 'March20kmResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SocResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } | { __typename: 'WeightResult' } }
);

export type FinSwimAssessmentResultDataFragment = (
  { __typename: 'FinSwimResult' }
  & Pick<SchemaTypes.FinSwimResult, 'timingSec'>
);

export const FinSwimAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment FinSwimAssessmentResultData on FinSwimResult {
  timingSec
}
    `;
export const FinSwimAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment FinSwimAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      role
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on FinSwimResult {
      ...FinSwimAssessmentResultData
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    `;
export const CreateFinSwimAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation CreateFinSwimAssessmentResult($input: SubmitFinSwimResultInput!) {
  submitFinSwimResult(input: $input) {
    __typename
    ... on SubmitFinSwimResultSuccessfulResponse {
      result {
        ...FinSwimAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        message
        field
      }
    }
  }
}
    ${FinSwimAssessmentResultFragmentDoc}
${FinSwimAssessmentResultDataFragmentDoc}`;
export type CreateFinSwimAssessmentResultMutationFn = Apollo.MutationFunction<CreateFinSwimAssessmentResultMutation, CreateFinSwimAssessmentResultMutationVariables>;

/**
 * __useCreateFinSwimAssessmentResultMutation__
 *
 * To run a mutation, you first call `useCreateFinSwimAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinSwimAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinSwimAssessmentResultMutation, { data, loading, error }] = useCreateFinSwimAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFinSwimAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<CreateFinSwimAssessmentResultMutation, CreateFinSwimAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFinSwimAssessmentResultMutation, CreateFinSwimAssessmentResultMutationVariables>(CreateFinSwimAssessmentResultDocument, options);
      }
export type CreateFinSwimAssessmentResultMutationHookResult = ReturnType<typeof useCreateFinSwimAssessmentResultMutation>;
export type CreateFinSwimAssessmentResultMutationResult = Apollo.MutationResult<CreateFinSwimAssessmentResultMutation>;
export type CreateFinSwimAssessmentResultMutationOptions = Apollo.BaseMutationOptions<CreateFinSwimAssessmentResultMutation, CreateFinSwimAssessmentResultMutationVariables>;